import React, { memo } from 'react';

interface QuickActionCardProps {
  /** カードタイトル */
  title: string;
  /** カードの説明 */
  description: string;
  /** アイコン */
  icon: React.ReactNode;
  /** クリック時のアクション */
  onClick: () => void;
  /** カラーテーマ（primary、secondary等） */
  color?: string;
}

/**
 * クイックアクションカードコンポーネント
 * ダッシュボードでよく使うアクションを表示するためのカード
 */
export const QuickActionCard: React.FC<QuickActionCardProps> = memo(
  ({ title, description, icon, onClick, color = 'primary' }) => (
    <div
      onClick={onClick}
      className='bg-white dark:bg-gray-800 p-6 rounded-lg shadow-md cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-1 card-touch touch-target button-touch focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 dark:focus:ring-offset-gray-900'
      tabIndex={0}
      role='button'
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className='flex items-center mb-4'>
        <div className={`p-2 rounded-lg bg-${color}-100 dark:bg-${color}-900/50 mr-3`}>{icon}</div>
        <h3 className='text-lg font-semibold text-gray-800 dark:text-white'>{title}</h3>
      </div>
      <p className='text-sm text-gray-600 dark:text-gray-300'>{description}</p>
    </div>
  )
);

QuickActionCard.displayName = 'QuickActionCard';
